function dw_getScrollOffsets() {
    var doc = document, w = window;
    var x, y, docEl;
    
    if ( typeof w.pageYOffset === 'number' ) {
        x = w.pageXOffset;
        y = w.pageYOffset;
    } else {
        docEl = (doc.compatMode && doc.compatMode === 'CSS1Compat')?
                doc.documentElement: doc.body;
        x = docEl.scrollLeft;
        y = docEl.scrollTop;
    }
    return {x:x, y:y};
}

export default () => {
  const $window = $(window);
  const $document = $(document);
  const $body = $('body');
  const $header = $('#js-header');
  const bodyFixedClass = 'has-fixed-header';

  let iScrollPos = 0;

  $window.scroll(function () {
    let iCurScrollPos = $(this).scrollTop();
    var off = dw_getScrollOffsets();
    //console.log('scrolled: '+off.y);
    //console.log('window height: '+$window.height());
    //console.log('cont height: '+ ($document.height() - $window.height()));
    // if not at the bottom of the page
    if($window.scrollTop() + $window.height() !== $document.height() || !$(window).scrollTop() <= 0) {
      if (iCurScrollPos > iScrollPos) {
        // scroll down
        if($body.hasClass(bodyFixedClass) && off.y > 0) {
          $body.removeClass(bodyFixedClass);
          $header.removeClass('is-fixed').addClass('not-fixed');
          //console.log('down');
        }
      } else {
        // scroll up
        
        if(!$body.hasClass(bodyFixedClass)  && off.y < ($document.height() - $window.height()) ) {
          $body.addClass(bodyFixedClass);
          $header.removeClass('not-fixed').addClass('is-fixed');
          //console.log('up');
        }
      }
      
      

      iScrollPos = iCurScrollPos;
    }
    if($(window).scrollTop() === 0){
          $body.addClass(bodyFixedClass);
          $header.removeClass('not-fixed').addClass('is-fixed');
          //console.log('top');
      }
  });
  
};

